// Sdílená hlavička pro sekce Skupina/Filtry/Produkt v levém menu StationGroupLayout — ikona + label
// + trojúhelník, který otevírá/zavírá detailní overlay panel vpravo (viz doc/plans/station-group-sidebar-redesign.md)
export function PanelHeader({ icon, label, expanded, onToggle }) {
  return (
    <button
      className="w-full flex items-center gap-2 px-3 py-2 border-b border-gray-100 text-xs font-semibold text-gray-500 uppercase tracking-wide hover:text-gray-700 hover:bg-gray-50 transition-colors"
      onClick={onToggle}
    >
      <img src={icon} className="w-6 h-6 shrink-0" alt="" />
      <span className="flex-1 text-left">{label}</span>
      <span className={`text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`}>▶</span>
    </button>
  )
}
